const routes = [
	/* @@GENERATOR:POD:ASSIGN */
	...require('~/pods/wage-declaration/routes').default,
	...require('~/pods/policy-cancel/routes').default,
	...require('~/pods/policy-payments/routes').default,
	...require('~/pods/account/routes').default,
	...require('~/pods/policy-update/routes').default,
	...require('~/pods/policy-renewal/routes').default,
	...require('~/pods/policy-details/routes').default,
	...require('~/pods/policy-hindsight/routes').default,
	...require('~/pods/policy-wage-declaration/routes').default,
	...require('~/pods/dashboard/routes').default,
	...require('~/pods/quote-application/routes').default,
	...require('~/pods/authentication/routes').default,
	...require('~/pods/site/routes').default,
];

export default routes;
